import { useRef } from 'react';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';

import type {
    TMappedFields,
    TFields,
    TMappedFioFields,
    TFioFields,
    IOnBlurFieldAnalyticsArgs,
} from './models';

const fioFieldKeys: TFioFields[] = ['firstName', 'lastName', 'middleName'];

const checkFieldState =
    (prevState: TMappedFields[TFields]) => (currentState: TMappedFields[TFields]) =>
        prevState?.error !== currentState?.error || prevState?.value !== currentState?.value;

export function useCachedValue<T>(initValue: T): [T, (newValue: T) => void] {
    const value = useRef<T>(initValue);

    return [
        value.current,
        newValue => {
            value.current = newValue;
        },
    ];
}

export function isValidFioFields(fields: TMappedFioFields) {
    return fioFieldKeys.every(
        fieldName =>
            !fields[fieldName]?.error && fields[fieldName]?.value && fields[fieldName]?.touched
    );
}

export function onBlurFieldAnalytics({
    activeField,
    analytics,
    cachedActive,
    cachedActiveField,
    fields,
}: IOnBlurFieldAnalyticsArgs) {
    /**
     * новые значения для поля, с которого перевели фокус
     * */
    const { error, touched } = activeField || {};
    /**
     * сравнение стейтов поля для определения дальнейших действий
     * */
    const isFieldChanged = checkFieldState(cachedActiveField)(activeField);
    if (touched && isFieldChanged) {
        /**
         * если с поля перевели фокус и его стейт поменялся
         * */
        if (error) {
            return sendEvent({ ...analytics[cachedActive]?.incorrect, error });
        }

        if (cachedActive === 'fullName') {
            const isFioFieldsHaveErrors = fioFieldKeys.some(key => fields[key]?.error);

            if (isFioFieldsHaveErrors) return;

            return sendEvent(analytics[cachedActive]?.correct);
        }

        return sendEvent(analytics[cachedActive]?.correct);
    }

    if (touched && error && cachedActive !== 'fullName') {
        /**
         * если с поля перевели фокус и ошибка не стала `undefined`, то отправляем ошибку
         * (изначально в `error` лежит ошибка валидации на "обязательность" поля)
         * также тут КОСТЫЛЬ для ФИО, тк при изменении `fullName` меняется еще 3 поля (firstName, middleName, lastName)
         * */
        return sendEvent({ ...analytics[cachedActive]?.incorrect, error });
    }
}
